<template>
  <navbar>
    <Loader :is-visible="loading" />

    <button
      class="navbar-toggler mobile-sidebar-toggler hidden-lg-up"
      type="button"
      @click="mobileSidebarToggle"
    >
      &#9776;
    </button>

    <a
      class="navbar-brand"
      href="#"
      :style="`background-color: ${brandColor}`"
    ></a>

    <ul class="nav navbar-nav hidden-md-down">
      <li class="nav-item">
        <a
          class="nav-link navbar-toggler sidebar-toggler"
          href="#"
          @click="sidebarToggle"
          >&#9776;</a
        >
      </li>
    </ul>

    <SearchBar
      v-if="
        isTeam(user) &&
        (hasPermission($store.state.user, 'CLIENTS_READ') ||
          hasPermission($store.state.user, 'USERS_MENU_READ') ||
          hasPermission($store.state.user, 'PAYMENTS_READ') ||
          hasPermission($store.state.user, 'ORDERS_READ'))
      "
    ></SearchBar>

    <ul class="nav navbar-nav ml-auto position-relative" v-if="user">
      <li class="nav-item px-1 d-none d-lg-block">
        {{ username }}
      </li>
      <li class="nav-item">
        <a class="nav-link nav-pill" @click="logout"
          ><i class="icon-logout"></i
        ></a>
      </li>
    </ul>
  </navbar>
</template>
<script>
import { mapState, mapActions } from "vuex";

import navbar from "@/components/layout/Navbar";
import SearchBar from "@/components/layout/SearchBar";
import Loader from "@/components/utils/Loader";

export default {
  components: {
    navbar,
    SearchBar,
    Loader,
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    ...mapState({
      merchants: (state) => state.merchants,
      merchant: (state) => state.merchant,
      invoiceSerie: (state) => state.invoiceSerie,
      invoiceSeries: (state) => state.invoiceSeries,
      user: (state) => state.user,
    }),

    brandColor() {
      const apiUrl = process.env.VUE_APP_API_URL;
      if (
        apiUrl.startsWith("https://api.justcoaching.fr") ||
        apiUrl.startsWith("https://api.moov-on.fr")
      ) {
        return "#2f323a";
      }

      return "var(--brand-primary)";
    },

    merchantLogo: function () {
      return this.$store.state.merchant.logo;
    },

    username() {
      let name;

      if (this.user.commercial) {
        name = this.user.commercial.pseudo;
      } else if (this.user.coachManager) {
        name = this.user.coachManager.pseudo;
      }

      return name || this.user.email;
    },
  },

  methods: {
    ...mapActions(["signOut"]),

    sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("sidebar-hidden");
    },

    mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("sidebar-mobile-show");
    },

    asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("aside-menu-hidden");
    },

    async logout() {
      try {
        this.loading = true;

        await this.signOut();
      } catch (e) {
        this.$toast.error("Une erreur est survenue lors de la déconnexion", e);
      } finally {
        this.loading = false;
      }

      this.$router.push({
        name: "login",
        query: {
          redirect: this.$route.fullPath,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.sidebar-mobile-show {
  .sidebar {
    z-index: 9999;
  }
}
</style>
